<template>
    <div class="middle">
               <div class="text-center">
                  <h1 class="heading">My Commodities</h1>
               </div>
               <br />
               <div class="productContent">
                  <div class="row">
                     <div class="col-lg-4 offset-lg-4 d-flex justify-content-center align-items-center">
                        <div style="width:100%; text-align:center">
                        <div style="width:625px">
                        <div class="onOffSwitch">
                           <div class="switchTxt">
                              <label class="switch active">
                              <span class="optionSelLeft active">Vegetables</span>
                              <span class="optionSelRight">Fruits</span>
                              <input type="checkbox"  id="input_checkBox" v-on:click = "changeList()"/>
                              <span class="slider round"></span>
                              </label>
                           </div>
                        </div>
                        </div>
                        </div>
                     </div>
                          <div class="col-lg-4">
                        <div class="productSearch">
                           <div class="input-group mb-3">
                              <input type="text" class="form-control" placeholder="Quick Search" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                              <div class="input-group-append">
                                 <span class="input-group-text" id="basic-addon2"><i class="fa fa-search" aria-hidden="true"></i></span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="productSlider product-border">
                  <div id="fruits" class="carousel slide" v-if = 'selected==false' data-ride="carousel" data-interval="false">
                     <div class="carousel-inner">
                        <div class="carousel-item active">
                           <div class="row">
                              <div class="col-lg-1"></div>
                              <div class="col-lg-10 pt-2">
                                 <div>
                                    <div class="col-lg-1 col-md-1 col-xs-1"></div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                       <div class="icon-dim"  @mouseover= "showText()">
                                          <div class="po" style="position:relative;">
                                             <img src="../assets/img/icons/fruits/Apple.svg" class="apple-bg icon-shape" data-icon-name="apple" />

                                          </div>
                                          <p class="text-name apple-text-color">Apple</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/Apricot.svg" class="apricot-bg icon-shape" data-icon-name="apricot" />
                                          <p class="text-name apricot-text-color">Apricot</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/Banana.svg" class="banana-bg icon-shape" data-icon-name="banana" alt="Banana" />
                                          <p class="text-name banana-text-color">Banana</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/Berry.svg" class="berry-bg icon-shape" data-icon-name="berry" />
                                          <p class="text-name berry-text-color">Berry</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/BlueBerry.svg" class="blueberry-bg icon-shape" data-icon-name="blueberry" alt="BlueBerry" />
                                          <p class="text-name blueberry-text-color">BlueBerry</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/Grapefruit.svg" class="grapefruit-bg icon-shape" alt="Grapefruit" data-icon-name="grapefruit" />
                                          <p class="text-name grapefruit-text-color">Grapefruit</p>
                                       </div>
                                    </div>
                                 </div>
                                 <div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                       <div class="icon-dim"  @mouseover = "showText()">
                                          <img src="../assets/img/icons/fruits/Orange.svg" class="orange-bg icon-shape" data-icon-name="orange" alt="Orange" />
                                          <p class="text-name orange-text-color">Orange</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                       <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                          <div class="icon-dim"  @mouseover = "showText()">

                                             <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="orange" />
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-lg-1"></div>
                              </div>
                           </div>
                        </div>
                        <a class="carousel-control-prev" href="#fruits" data-slide="prev">
                        <span class="carousel-control-prev-icon">
                        <img src="../assets/img/Arrow.svg" class="rotateimg" />
                        </span>
                        </a>
                        <a class="carousel-control-next" href="#fruits" data-slide="next">
                        <span class="carousel-control-next-icon"> <img src="../assets/img/Arrow.svg" /></span>
                        </a>
                     </div>
                  </div>
                  <div id="vegetables" class="carousel slide" v-if = "selected==true" data-ride="carousel" data-interval="false">
                     <div class="carousel-inner">
                        <div class="carousel-item active">
                           <div class="row">
                              <div class="col-lg-1"></div>
                              <div class="col-lg-10 pt-2">
                                 <div>
                                    <div class="col-lg-1 col-md-1 col-xs-1"></div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                        <div class="icon-dim"  @mouseover = "showText()">

                                          <img src="../assets/img/icons/vegetables/Potato.svg" class="potato-bg icon-shape" alt="Potato" data-icon-name="potato" />
                                          <p class="text-name potato-text-color">Potato</p>
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                        <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                        <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                        <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                        <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                      
                                    </div>
                                 </div>
                                 <div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                 </div>
                                 <div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center ">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="no-icon">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim"  @mouseover = "showText()">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim berry">

                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="greyBox" />
                                       </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6 float-left text-center">
                                       <div class="icon-dim apple">
                                          <span class="bottom-right-triangle triangle-position-bottom "></span>
                                          <img src="../assets/img/dot.png" class="icon-shape dot-dim gray-box " data-icon-name="apple" />
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="col-lg-1"></div>
                           </div>
                        </div>
                        <a class="carousel-control-prev" href="#vegetables" data-slide="prev">
                           <span class="carousel-control-prev-icon">
                           <img src="../assets/img/Arrow.svg" class="rotateimg" />
                           </span>
                           </a>
                           <a class="carousel-control-next" href="#vegetables" data-slide="next">
                           <span class="carousel-control-next-icon"> <img src="../assets/img/Arrow.svg" /></span>
                        </a>
                     </div>
                  </div>
                    
               </div>
                     
            </div>
</template>


<script>
import {
  Component,
  Prop,
  Vue
} from "vue-property-decorator";
    export default {
        name : "MyCommodities",
        data() {
            return {
                authenticated : true,
                selected : true
            };
        },
        methods : {
            changeList(){
               var ele = document.getElementById('input_checkBox');
               if(ele.checked){
                  this.selected = false;
                   $('.optionSelLeft').removeClass('active');
                   $('.optionSelRight').addClass('active');
                   $('#vegetables').show();
               }else{
                  this.selected = true;
                   $('.optionSelRight').removeClass('active');
                   $('.optionSelLeft').addClass('active');
                  $('#fruits').show();
               }
            },
            showText(){ 
            //   var ele = document.getElementById(id);
            //    $(ele).find('.text-name').addClass('show');
              // $(ele).find('.text-name').removeClass('show');
               $('.icon-dim').hover(function () {
                  $(this).find('.text-name').addClass('show');
               }, function () {
                  $(this).find('.text-name').removeClass('show');
               });     
            }
        }
    }
</script>